import { ThemeProvider } from "@mui/material/styles";
import theme from "./styles/theme";
import "./App.css";
import { Signin } from "./pages/auth/Signin";
import { ForgotPassword } from "./pages/auth/ForgotPassword";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ResetPassword } from "./pages/auth/ResetPassword";
import { Dashboard } from "./pages/dashboard";
import { Error404 } from "./pages/errors/Error404";
import { Error403 } from "./pages/errors/Error403";
import { AuthProvider } from "./contexts/AuthContext";
import { Signup } from "./pages/auth/Signup";
import { API } from "./pages/api";

import { Users } from "./pages/users";
import { Settings } from "./pages/settings";
import UserEditPage from "./pages/users/edit";
import Test from "./pages/test";
import { ProtectedRoute } from "./components/global/ProtectedRoute";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/password/forgot" element={<ForgotPassword />} />
            <Route path="/password/reset" element={<ResetPassword />} />
            <Route path="/api" element={<API />} />
            <Route path="/test" element={<Test />} />

            <Route
              path="/users"
              element={
                <ProtectedRoute allowedRoles={[0, 2]}>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/new"
              element={
                <ProtectedRoute allowedRoles={[0, 2]}>
                  <UserEditPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/edit/:userId"
              element={
                <ProtectedRoute allowedRoles={[0, 2]}>
                  <UserEditPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings"
              element={
                <ProtectedRoute allowedRoles={[3]}>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route path="/403" element={<Error403 />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
